import utils from './tools';
import http from '../services/http';

export default class ProductService {
  constructor($http) {
    this.$http = $http;
  }

  /**
   * 获取商品编号
   *
   * @returns {Number} 商品编号
   * @memberof ProductService
   */
  getProductId() {
    return parseInt(this.getParamByName('visa_product_id'));
  }

  getIdentityId() {
    return parseInt(this.getParamByName('identity_id'));
  }

  getParamByName(name) {
    utils.noop(this);
    let str = '';
    try {
      str = location.href.split(`${name}=`)[1].split('&')[0];
    } catch (error) {
      str = '';
    }
    return str;
  }

  /**
   * 加载商品数据
   *
   * @returns {Promise}
   * @memberof ProductService
   */
  getProduct(productId) {
    return http.post('h5/visa_product_query', {
      visa_product_id: productId,
    });
  }

  /**
   * 转化summaryInfo
   *
   * @param {any} summaryInfo
   * @returns
   * @memberof ProductService
   */
  parseProductSummaryInfo(summaryInfo) {
    if (!summaryInfo) return {};

    const summmary = {};

    // 办理时长
    if (summaryInfo.length >= 0) {
      summmary.handlePeriod = {
        title: summaryInfo[0].title,
        content: summaryInfo[0].content,
      };
    }

    // 有效期限
    if (summaryInfo.length >= 1) {
      summmary.validityPeriod = this.parseSummaryContent(summaryInfo[1]);
    }

    // 最长停留
    if (summaryInfo.length >= 2) {
      summmary.maxStayTime = this.parseSummaryContent(summaryInfo[2]);
    }

    // 入境次数
    if (summaryInfo.length >= 3) {
      summmary.numberOfEntry = this.parseSummaryContent(summaryInfo[3]);
    }

    return summmary;
  }

  /**
   * 分离单个summary
   *
   * @param {any} sumary
   * @returns
   * @memberof ProductService
   */
  parseSummaryContent(sumary) {
    utils.noop(this);

    if (!sumary) return {};

    const reg = /\D/g;

    let content = {};

    const stringArr = sumary.content.split(reg);

    // 如果第一个字符没找到数字,代表是描述行的,如果"多次"
    if (stringArr[0] === '') {
      // 如果是字符就显示字符
      content = {
        isAllString: true,
        str: sumary.content,
      };
    } else {
      // 如果是数字,需要单独分离出来,展示特殊样式
      content = {
        isAllString: false,
        num: stringArr[0],
        str: sumary.content.substring(
          stringArr[0].length,
          sumary.content.length,
        ),
      };
    }

    return {
      title: sumary.title,
      content,
    };
  }

  /**
   * 为身份数据排序
   * { id: 0, name: '在职人员' }, { id: 1, name: '自由职业者' }, { id: 2, name: '退休人员' },
   * { id: 3, name: '在校学生' }, { id: 4, name: '学龄前儿童' }
   * @param {any} productMaterials
   * @memberof ProductService
   */
  sortIdentitiesData(productMaterials) {
    utils.noop(this);

    if (productMaterials.length === 5) {
      // 拿出前面三个身份(下标从0开始不包含3)的数据{ firstThreeIdentitesData: [0, 1, 2], productMaterials: [3, 4] }
      const firstThreeIdentitesData = productMaterials.splice(0, 3);

      // 从下标为2的项后删除0个元素,并插入前三个身份的数据{ productMaterials: [3, 4, 0, 1, 2] }
      productMaterials.splice(2, 0, ...firstThreeIdentitesData);

      // 从第1位后删除1个元素, { secondIndentityData: [5], productMaterials: [3, 0, 1, 2] }
      const secondIndentityData = productMaterials.splice(1, 1);

      // 从第1位后删除0个元素,插入上面的定二个身份 { productMaterials: [4, 3, 0, 1, 2] }
      productMaterials.splice(0, 0, ...secondIndentityData);

      return productMaterials;
    }

    // 取出第一个身份数据
    const firstIdentityData = productMaterials.splice(0, 1);

    // 找到中间位置
    const startIndex = Math.ceil((productMaterials.length - 1) / 2);

    // 将第一个身份数据插入到中间
    productMaterials.splice(startIndex, 0, ...firstIdentityData);

    return productMaterials;

    // 有在职就中间

    // 学龄 在校 在职 自由 退休
  }

  /**
   *为每个资料分类和设置type属性
   *
   * @param {any} identitiesData
   * @memberof ProductService
   */
  parseIdentitiesData(identitiesData) {
    utils.noop(this);

    const identitiesDataResult = [];
    let tempIdentityData = null;

    for (let i = 0; i < identitiesData.length; i++) {
      // 生成的身份资料是同顺序的
      identitiesDataResult[i] = {
        0: [], // app拍摄资料
        1: [], // 邮寄资料
        2: [], // 赴馆资料
      };

      tempIdentityData = identitiesData[i];

      // 必备资料(包含电子资料,纸质资料,赴管资料)
      for (let j = 0; j < tempIdentityData.material_required.length; j++) {
        const requiredMaterial = tempIdentityData.material_required[j];

        // 必备标记
        requiredMaterial.type = 1;
        identitiesDataResult[i][
          tempIdentityData.material_required[j].attr
        ].push(requiredMaterial);
      }

      // 可选资料(包含电子资料,纸质资料,赴管资料)
      for (let j = 0; j < tempIdentityData.material_optional.length; j++) {
        const optionalMaterial = tempIdentityData.material_optional[j];

        // 可选标记
        optionalMaterial.type = 0;
        identitiesDataResult[i][
          tempIdentityData.material_optional[j].attr
        ].push(optionalMaterial);
      }
    }

    return this.changeMaterialTypeName(identitiesDataResult);
  }

  changeMaterialTypeName(identitiesDataResult) {
    utils.noop(this);

    if (!identitiesDataResult) return identitiesDataResult;

    const parsedIdentitiesArr = [];

    if (identitiesDataResult.length > 0) {
      identitiesDataResult.forEach((identity) => {
        parsedIdentitiesArr.push({
          elec: identity[0],
          papery: identity[1],
          take: identity[2],
        });
      });
    }

    return parsedIdentitiesArr;
  }
}
